import Vue from "vue"
import Vuex from "vuex"
import axios from "axios"
import createPersistedState from "vuex-persistedstate"

import router from "@/router"
import Auth from "@/store/modules/auth"
import Cart from "@/store/modules/cart"
import Course from "@/store/modules/course"
import Wishlist from "@/store/modules/wishlist"
import Settings from "@/store/modules/settings"
import Theme from "@/store/modules/theme"
import Helper from "@/services/helper"
import Api from "@/services/api"

Vue.use(Vuex)

const vuexStore = new Vuex.Store({
  // Auth is deliberately excluded: it holds no token (the session lives in an
  // HTTP-only cookie) and shouldn't linger in localStorage across sessions.
  plugins: [createPersistedState({ paths: ["Cart", "Wishlist", "Course", "Settings", "Theme"] })],
  state: {

  },
  mutations: {

  },
  actions: {

  },
  modules: {
    Auth,
    Cart,
    Wishlist,
    Course,
    Settings,
    Theme,
  },
})
// Send the session cookie with every request and echo the readable
// XSRF-TOKEN cookie back as a header on cross-origin requests.
axios.defaults.withCredentials = true;
axios.defaults.withXSRFToken = true;

const apiOrigin = Api.getOrigin();
axios.interceptors.request.use((config) => {
    const method = (config.method || 'get').toLowerCase();
    if (method !== 'get' && config.url && config.url.indexOf(apiOrigin) === 0) {
        return Api.ensureCsrfCookie().then(() => config);
    }
    return config;
});
axios.interceptors.response.use(response => response, function (error) {
    if (error?.response?.status == 401) {
        Helper.clearToken()
    }
    if (error?.response?.data?.message == 'Unauthorized' || error?.response?.status == 418) {
        Helper.clearToken()
        router.push({ name: "Home" }).catch(()=>{});
    }
    // The CSRF cookie was fetched once at page load and memoized (see
    // Api.ensureCsrfCookie); if the server session has since expired or the
    // cookie was cleared, that stale cookie 419s on every request thereafter.
    // Reset the memo and retry the request once with a freshly fetched cookie.
    if (error?.response?.status == 419 && !error.config?._retriedCsrf) {
        error.config._retriedCsrf = true;
        Api.resetCsrfCookie();
        return Api.ensureCsrfCookie().then(() => axios(error.config));
    }
    return Promise.reject(error);
});
export default vuexStore